import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionEditComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FillInBlankExtension } from './extensions/fill-in-blank.extension';
import { PlusOutlined } from '@ant-design/icons';
import { UniqueEntityID } from '@digibricks/core';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { FibAnswerItem } from './components/fib-answer-item.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswersSection = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding8'));
var StyledAnswersTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n"])), getSize('typo16'));
var StyledFibWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .custom-menu-item-add-blank {\n    background-color: #dbeafe !important;\n    color: #2563eb !important;\n    border-radius: ", " !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 4px !important;\n    padding: 2px 8px !important;\n    height: 32px !important;\n    font-weight: 600 !important;\n\n    &:hover {\n      background-color: #bfdbfe !important;\n    }\n\n    span {\n      color: #2563eb !important;\n    }\n  }\n"])), getSize('radiusS'));
var StyledAnswersList = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding12'));
export var FillInBlankEditComponent = function FillInBlankEditComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var fibQuestion = question;
  var fillInBlankLabel = states.fillInBlankLabel;
  var isUpdatingFromEditor = useRef(false);
  var editorRef = useRef(null); // Track editor instance for programmatic updates

  var answerRefs = useRef({});

  var _useState = useState(null),
      selectedBlankId = _useState[0],
      setSelectedBlankId = _useState[1]; // Sync with prop when it substantially changes (e.g. from Redux after save or after delete)


  useEffect(function () {
    // Only sync if update is not from editor itself
    if (!isUpdatingFromEditor.current) {
      // Update editor HTML content to trigger blank component re-indexing
      // This ensures blank indexes are recalculated when a blank is deleted
      if (editorRef.current && editorRef.current.commands) {
        var currentHtml = editorRef.current.getHTML();

        if (currentHtml !== fibQuestion.description) {
          // Set content first
          editorRef.current.commands.setContent(fibQuestion.description, false); // false = don't add to history
          // Force re-render all NodeViews by triggering a transaction
          // This ensures blank components recalculate their displayIndex after delete

          setTimeout(function () {
            if (editorRef.current && editorRef.current.state && editorRef.current.view) {
              var _editorRef$current = editorRef.current,
                  state = _editorRef$current.state,
                  view = _editorRef$current.view;
              var tr = state.tr; // Set meta to indicate this is a force update for NodeViews

              tr.setMeta('forceUpdate', true);
              view.dispatch(tr);
            }
          }, 0);
        } else {
          // Even if description hasn't changed, force re-render when answers count changes
          // This handles case when blank is deleted from answers section (not from editor)
          // The description stays the same but we need to reindex remaining blanks
          //
          // SOLUTION: Destroy and recreate editor content to force NodeView remount
          // This ensures blank components recalculate their displayIndex properly
          setTimeout(function () {
            if (editorRef.current && editorRef.current.commands) {
              var currentContent = editorRef.current.getHTML(); // Clear content first to unmount all NodeViews

              editorRef.current.commands.setContent('', false); // Then immediately set it back to remount with fresh context
              // Use a small delay to ensure unmounting is complete

              setTimeout(function () {
                if (editorRef.current && editorRef.current.commands) {
                  editorRef.current.commands.setContent(currentContent, false); // Force one more render after remount to trigger re-indexing

                  setTimeout(function () {
                    if (editorRef.current && editorRef.current.state && editorRef.current.view) {
                      var _editorRef$current2 = editorRef.current,
                          state = _editorRef$current2.state,
                          view = _editorRef$current2.view;
                      var tr = state.tr;
                      tr.setMeta('reindexBlanks', true);
                      view.dispatch(tr);
                    }
                  }, 10);
                }
              }, 10);
            }
          }, 0);
        }
      }
    }

    isUpdatingFromEditor.current = false;
  }, [fibQuestion.description, fibQuestion.answers.length]); // Add answers.length dependency to trigger reindex
  // Handle blank click in text editor

  var handleBlankClick = useCallback(function (blankId) {
    setSelectedBlankId(blankId); // Auto-scroll to answer item for better UX

    setTimeout(function () {
      var answerElement = answerRefs.current[blankId];

      if (answerElement) {
        answerElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 100);
  }, []);
  var customMenuItems = useMemo(function () {
    return [{
      key: 'add-blank',
      label: 'Add Blank',
      icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
      onClick: function onClick(editor) {
        var id = new UniqueEntityID().toString(); // Step 1: Insert the blank node into editor first

        editor.chain().focus().insertContent({
          type: 'fillInBlank',
          attrs: {
            id: id
          }
        }).insertContent(' ').run(); // Step 2: Get updated HTML and update both description and answer together
        // Use setTimeout to ensure editor DOM is updated before getting HTML
        // This ensures description includes the newly inserted blank component

        setTimeout(function () {
          var updatedHtml = editor.getHTML();
          isUpdatingFromEditor.current = true; // Update both description and answer in one atomic operation
          // This ensures they are always in sync in the draft question

          if (actions.onAddBlankAnswerWithDescription) {
            actions.onAddBlankAnswerWithDescription(id, updatedHtml);
          } else {
            // Fallback to old method if new method not available
            actions.onUpdateDescription(question.id.toString(), updatedHtml);
            setTimeout(function () {
              actions.onAddBlankAnswer(id);
            }, 0);
          }
        }, 0);
      },
      showDivider: true
    }];
  }, [actions, question.id]);
  var handleDeleteBlank = useCallback(function (id) {
    if (actions.onDeleteBlankAnswer) {
      // Chỉ cần gọi function này, nó sẽ xử lý tất cả:
      // - Xóa answer và correctAnswer
      // - Xóa blank tag từ description trong draft question
      // - Update nextIndex
      // localDescription sẽ được sync tự động từ draft question.description qua useEffect
      actions.onDeleteBlankAnswer(id);
    }
  }, [actions]);
  var customExtensions = useMemo(function () {
    return [FillInBlankExtension.configure({
      // Removed deleteBlank to hide delete button on text editor
      // Users can only delete blanks from the answers section below
      onBlankClick: handleBlankClick
    })];
  }, [handleBlankClick]);
  var answerItems = useMemo(function () {
    return fibQuestion.answers.map(function (answer, index) {
      var correctAnswer = fibQuestion.correctAnswers.find(function (ca) {
        return ca.answerId === answer.id.toString();
      }) || {
        score: 1
      };
      return /*#__PURE__*/_jsx(FibAnswerItem, {
        ref: function ref(el) {
          return answerRefs.current[answer.id.toString()] = el;
        },
        index: index,
        answer: answer,
        score: correctAnswer.score,
        readonly: false,
        isSelected: selectedBlankId === answer.id.toString(),
        onUpdateAnswer: function onUpdateAnswer(val) {
          return actions.onUpdateAnswer(answer.id.toString(), val);
        },
        onUpdateScore: function onUpdateScore(val) {
          return actions.onUpdateAnswerScore(answer.id.toString(), val);
        },
        onDelete: function onDelete() {
          return handleDeleteBlank(answer.id.toString());
        },
        fillInBlankLabel: fillInBlankLabel
      }, answer.id.toString());
    });
  }, [fibQuestion, // Use local answers variable
  selectedBlankId, actions.onUpdateAnswer, actions.onUpdateAnswerScore, handleDeleteBlank, // Keep this as it's used in the callback
  fillInBlankLabel]);
  return /*#__PURE__*/_jsx(StyledFibWrapper, {
    children: /*#__PURE__*/_jsx(BaseQuestionEditComponent, {
      states: _objectSpread(_objectSpread({}, states), {}, {
        textEditorCustomMenuItems: customMenuItems,
        textEditorCustomExtensions: customExtensions
      }),
      actions: _objectSpread(_objectSpread({}, actions), {}, {
        onUpdateDescriptionImmediate: function onUpdateDescriptionImmediate(questionId, val) {
          isUpdatingFromEditor.current = true; // Call original action if exists

          if (actions.onUpdateDescriptionImmediate) {
            actions.onUpdateDescriptionImmediate(questionId, val);
          }
        },
        onEditorReady: function onEditorReady(editor) {
          editorRef.current = editor;
        }
      }),
      children: fibQuestion.answers.length > 0 && /*#__PURE__*/_jsxs(StyledAnswersSection, {
        children: [/*#__PURE__*/_jsx(StyledAnswersTitle, {
          children: fillInBlankLabel.answers
        }), /*#__PURE__*/_jsx(StyledAnswersList, {
          children: answerItems
        })]
      })
    })
  });
};